import React, { useState } from 'react';

function PreSaveButton() {
  const [isHovered, setIsHovered] = useState(false);

  const handlePreSave = () => {
    window.location.href = 'https://oauth-worker.hubertdoubek12.workers.dev/authorize';
};

  return (
    <button 
      className={`spotify-pre-save-button ${isHovered ? 'hovered' : ''}`}
      onClick={handlePreSave}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      Pre-Save Now
    </button>
  );
}

export default PreSaveButton;